<div class="hmf-display-flex hmf-flex-wrap hmf-justify-content-center">
	<div class="tech-icons hmf-col hmf-span-sm-12 hmf-span-md-6 hmf-span-lg-3" *ngFor="let techIcons of techIconsArray; trackBy: trackByFn;">
		<div class="hmf-display-flex hmf-justify-content-center hmf-align-items-center">
			<shared-media-component-media
				class="tech-icons-img"
				*ngIf="techIcons?.image || techIcons?.visualAssets || techIcons?.youtubeId || techIcons?.animation"
				[visualAssets]="techIcons?.visualAssets"
				[altText]="techIcons?.altText"
				[image]="techIcons?.image"
				[mobileImg]="techIcons?.mobileImg"
				[itemTitle]="techIcons?.headline"
				[youtubeId]="techIcons?.youtubeId"
				[animation]="techIcons?.animation">
			</shared-media-component-media>
		</div>
		<div class="header hmf-display-flex hmf-justify-content-center" [innerHTML]="techIcons?.headline | dcsgSanitizeHtml"></div>
		<div *ngIf="techIcons?.subCopy !== undefined" class="meta hmf-display-flex hmf-justify-content-center" [innerHTML]="techIcons?.subCopy | dcsgSanitizeHtml"></div>
	</div>
</div>
